import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router';

import paths from '@/lib/paths';
import { toDateString } from '@/lib/utils/date';
import formatCurrency from '@/lib/utils/formatCurrency';

import type { Claim } from '../../types';

type Props = {
  claim: Claim;
};

export default function ClaimItem({ claim }: Props) {
  const { t } = useTranslation();

  return (
    <Link
      to={generatePath(paths.claims.detail, { id: claim.id })}
      className="shadow-card flex flex-col gap-2 rounded-lg border p-2"
    >
      <div className="flex flex-col">
        <span className="flex items-center gap-1 text-sm leading-tight">
          <ShieldAlert className="size-3.5" />

          {claim.type_of_coverage}
        </span>

        <span className="text-muted-foreground text-xs">
          {toDateString(claim.claim_date)}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('CLAIMS_AMOUNT')}
          </span>

          <span className="text-xs">
            {formatCurrency(claim.total_amount) ?? '-'}
          </span>
        </div>

        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('CLAIMS_POLICY_NR')}
          </span>

          <span className="text-xs">{claim.anva_policy_nr ?? '-'}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('CLAIMS_COVERAGE')}
          </span>

          <span className="text-xs">{claim.type_of_coverage ?? '-'}</span>
        </div>

        <div className="flex flex-col">
          <span className="text-muted-foreground text-[10px] uppercase">
            {t('CLAIMS_DEDUCTIBLE')}
          </span>

          <span className="text-xs">
            {formatCurrency(claim.own_risk) ?? '-'}
          </span>
        </div>
      </div>
    </Link>
  );
}
